export default __webpack_public_path__ + "static/Ringside-Bold-0e294aeae4be5fb9d9093c75d285ffa2.woff2";